import React from 'react';
import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import compose from 'recompose/compose';
// Material helpers
import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Box, Card, CardContent, Grid } from '@material-ui/core';

// Shared components
import TextField from '@material-ui/core/TextField/index';
import IconButton from '@material-ui/core/IconButton';
import Loading from '../../../../../utils/Loading';
import Variable from '../../../../../helpers/Template/Variable';
import { saveTemplateAdd } from '../../../../../services/Templates';
import moment from 'moment';
import 'moment/locale/es';
import { Button } from '@material-ui/core';
import { toast } from 'react-toastify';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

// Component styles
import styles from './styles';
moment.locale('es')

class NewTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldState: { name: "", desc: "", upload: "", code: "" },
      errorStates: ["Es necesario Ingresar Nombre, Descripcion, icono y Codigo", "Ingrese Nombre", "Ingrese Descripción", "Ingrese Icono", "Ingrese Codigo", "error de conexión"],
      defaultJson: '[{"fecha_evento":"$[fecha] $[hora]"},{"evento":"$[motivo]"}]',
      sucess: false,
      indexError: "",
      loadError: false,
      isLoad: false,
      file: `favicon.ico`,
      img: ""
    }
  }

  handleFieldChange = (field, value) => {
    const { fieldState } = this.state
    if (field == "upload") {
      var fileImg = value.target.files
      if (fileImg.length > 0) {
        const file = URL.createObjectURL(fileImg[0]);
        this.setState({
          file: file,
          img: fileImg
        });
      }
    }
    const newFieldState = { ...fieldState, [field]: value }
    this.setState({ fieldState: newFieldState })
  };
  save = async () => {
    const { t } = this.props;
    const { fieldState, img, defaultJson, file } = this.state

    if (fieldState.name == "" && fieldState.descripcion == "" && fieldState.code == "") {
      this.setState({
        indexError: 0,
        loadError: true
      });
    } else if (fieldState.name == "") {
      this.setState({
        indexError: 1,
        loadError: true
      });
    } else if (fieldState.desc == "") {
      this.setState({
        indexError: 2,
        loadError: true,
      });
    } else {
      const token = sessionStorage.getItem('key')
      const user = sessionStorage.getItem('user')
      var code = fieldState.code
      if (fieldState.code == "") {
        code = defaultJson
      }
      let image = process.env.REACT_APP_IMAGE_ATENTUS      
      if (img !== "") {
        image = await new Promise((resolve) => {
          var reader = new FileReader();
          reader.readAsDataURL(img[0]);
          reader.onload = () => {
            resolve(reader.result.replace("data:image/png;base64,", ''));
          }
        });
      }
      saveTemplateAdd(user, token, fieldState.name, fieldState.desc, image, code, 'add', '').then(value => {
        if (value === "success") {
          this.setState({
            indexError: false,
            loadError: false,
            isLoad: false,
            sucess: true
          });
          setTimeout(() => { this.props.handleTemplate() }, 2000)
          toast.success(t ? t('templateManager.add.success') : 'Template Ingresado')
        } else {
          this.setState({
            indexError: 5,
            loadError: true,
            isLoad: false,
            sucess: false
          });
          toast.error(t ? t(`templateManager.add.error.${5}`) : this.state.errorStates[5])
        }
      })
      this.setState({
        indexError: false,
        loadError: false,
        isLoad: true,
      });
    }
  }
  render() {
    const { classes, t } = this.props;
    const { isLoad, defaultJson, file } = this.state
    return (
      <Card>
        <CardContent>
          <Box display="flex" alignItems="center">
            <IconButton onClick={this.props.handleTemplate} style={{ marginRight: 4 }}>
              <ArrowBackIcon />
            </IconButton>
            <Box>
              <Typography className={classes.textGrey} variant="h4">{t ? t('templateManager.add.title') : 'Crear Template'}</Typography>
              <Typography className={classes.textGrey} style={{ marginTop: 2 }} variant="body2">{t('template-management.information.text1')}</Typography>
            </Box>
          </Box>
          <Grid container spacing={2} style={{ marginTop: 8 }}>
            <Grid item xs={12} sm={12} md={6} xl={4}>
              <Box>
                <TextField
                  label={t ? t('templateManager.add.label.name') : 'Nombre'}
                  name="name"
                  type="text"
                  required
                  onChange={event =>
                    this.handleFieldChange('name', event.target.value)
                  }
                  variant="outlined"
                  inputProps={{ maxLength: 40 }}
                  size='small'
                  fullWidth
                />
              </Box>
              <Box marginTop={2}>
                <TextField
                  label={t ? t('templateManager.add.label.description') : 'Descripcion'}
                  name="descripcion"
                  type="text"
                  required
                  variant="outlined"
                  onChange={event =>
                    this.handleFieldChange('desc', event.target.value)
                  }
                  inputProps={{ maxLength: 40 }}
                  size='small'
                  fullWidth
                  multiline
                  rows={5}
                />
              </Box>
              <Box marginTop={2}>
                <Box className={classes.uploadArea}>
                  <input
                    type="file"
                    onChange={event => this.handleFieldChange('upload', event)}
                    id="upload"
                    accept="image/png"
                    className={classes.fileInput}
                  />
                  <label htmlFor="upload" className={classes.uploadLabel}>
                    <CloudUploadIcon className={classes.uploadIcon} />
                    <Typography variant="body2">Seleccionar imagen</Typography>
                  </label>
                </Box>
                <Box className={classes.imagePreview}>
                  <img className={classes.img} alt="icono" src={file} />
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={6} xl={4}>
              <Box>
                <TextField
                  style={{ border: "0.2px solid grey" }}
                  id="standard-multiline-static"
                  label={t ? t('templateManager.add.label.insertCode') : 'Inserte Codigo'}
                  name="code"
                  defaultValue={defaultJson}
                  multiline
                  rows={13}
                  onChange={event =>
                    this.handleFieldChange('code', event.target.value)
                  }
                  fullWidth
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={6} xl={4}>
              <Box>
                <Variable />
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={12} xl={12}>
              <Box marginTop={2} display='flex' justifyContent='right'>
                <Button disabled={isLoad} onClick={this.save} className={classes.buttonSave}>{t ? t('templateManager.add.button.save') : 'Guardar'}</Button>
              </Box>
              {isLoad ?
                <Loading />
                :
                null
              }
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    )
  }
}

export default compose(withStyles(styles), withTranslation())(NewTemplate);
